import Button from "common/Button";
import FormFields from "components/Form";
import React, { useContext, useState } from "react";
import styles from "./onBoard.module.css";
import { BurgerMenuContext } from "context/sidebar";
import { postData, SearchOptions } from "utils/queries";

const OnBoardAccount = ({ getAllStripeAccounts, sidebarRef }) => {
  const [requestPayout, setRequestPayout] = useState({
    amount: 0,
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    country: "GB",
  });

  const burgerContext = useContext(BurgerMenuContext);

  // const updateSidebar = () =>{
  //   burgerContext.updateComp({comp:<BankAccount/>,right:true,isOpen:true})
  //   burgerContext.setShowSideBar(true)
  // }

  const handleChange = (label) => (e) => {
    setRequestPayout((prevDetails) => ({
      ...prevDetails,
      [label]: e.target ? e.target.value : e,
    }));
  };

  const fetchOptions = async (search) => {
    try {
      const optionsResult = await SearchOptions(`ticket/search?key=${search}`);

      console.log("optionresult", optionsResult);
      return optionsResult?.data?.data
        ?.filter((e) =>
          e?.event_name?.toLowerCase().includes(search.toLowerCase())
        )
        ?.map((e) => ({
          value: e?.id,
          label: e?.event_name,
          starts: e?.starts,
          ends: e?.ends,
          asfdasdf: "asdfasdf",
        }));
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };

  const fetchAccountsOptions = async (search) => {
    try {
      const optionsResult = await SearchOptions(`stripe/search?key=${search}`);

      console.log("optionresult", optionsResult);
      return optionsResult?.data?.data
        ?.filter((e) =>
          e?.holder_name?.toLowerCase().includes(search.toLowerCase())
        )
        ?.map((e) => ({
          value: e?.id,
          label: `${e?.holder_name} (${e?.email})}`,
          stripe_id: e?.stripe_account_id,
        }));
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };

  const Fields = [
    // {
    //   label: "Your Details",
    //   subInfo:
    //     "Please provide your details so we can contact you if there are any issues with the payout.",
    //   component: (
    //     <>
    //       <label>Your Details</label>
    //       <div className={styles.info}>
    //         Please provide your details so we can contact you if there are any
    //         issues with the payout.
    //       </div>
    //     </>
    //   ),
    //   field: false,
    // },
    {
      label: "Account Holder Name",
      id: "holderName",
      placeholder: "Event Account Holder Name",
      type: "text",
      value: requestPayout?.holderName,
      required: false,
      onChange: handleChange("holderName"),
    },
    {
      label: "Holder Address",
      id: "holderAddress",
      placeholder: "Event Holder Address",
      type: "text",
      value: requestPayout?.holderAddress,
      required: false,
      onChange: handleChange("holderAddress"),
    },
    {
      label: "Email Address",
      id: "email",
      placeholder: "Event Email Address",
      type: "email",
      value: requestPayout?.email,
      required: false,
      onChange: handleChange("email"),
    },
    {
      label: "Country",
      id: "country",
      placeholder: "Event Country",
      type: "text",
      disabled: true,
      value: requestPayout?.country,
      required: false,
      onChange: handleChange("country"),
    },
    {
      label: "Phone number",
      id: "phoneNumber",
      placeholder: "Event Phone number",
      type: "tel",
      value: requestPayout?.phoneNumber,
      required: false,
      onChange: handleChange("phoneNumber"),
    },
    {
      label: "Account Type",
      id: "accountType",
      placeholder: "Account Type",
      type: "select",
      // options: [{ label: "individual", value: "individual" }],
      options: [{ label: "individual", value: "individual" }].map((opt) => ({
        ...opt,
        label: opt.label.charAt(0).toUpperCase() + opt.label.slice(1).toLowerCase(),
      })),
      value: requestPayout?.accountType,
      required: false,
      onChange: handleChange("accountType"),
    },
  ];

  const handleOnBoardAccount = async (e) => {
    e?.preventDefault();
    try {
      const obj = {
        ...requestPayout,
        accountType: requestPayout?.accountType?.value,
      };

      console.log("obje is", obj);
      const requestedPayout = await postData(`stripe/connectAccount`, {
        ...requestPayout,
        accountType: requestPayout?.accountType?.value,
      });

      console.log("requested payout details", requestedPayout);

      if (requestedPayout) {
        getAllStripeAccounts();
        burgerContext.setShowSideBar(false);
      }
    } catch (error) {}
  };

  return (
    <div className={styles.container} id="requestPayout" ref={sidebarRef}>
      <div className={styles.header}>
        <div className={styles.label}>Request OnBoard</div>
        <img
          src="/icons/cancel.svg"
          alt="Cancel"
          onClick={() => {
            burgerContext.setShowSideBar(false);
          }}
        />{" "}
      </div>
      <div className={styles.subLabel}>
        Complete the form below to request the onboard of an Account Holder .
        Please get in touch with your Account Manager or
        with accounts@flow.com if you require assistance.
      </div>
      <form onSubmit={handleOnBoardAccount}>
        {Fields?.map((e) => {
          if (e?.field == false) {
            return e?.component;
          }

          return (
            <>
              {e?.parentLabel && (
                <label
                  style={{
                    display: "block",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  {e?.parentLabel}
                </label>
              )}

              <FormFields Fields={[e]} />
            </>
          );
        })}
        {/* <label>Bank Account</label> */}
        {/* <Button label={"Add new account"} onClick={() => {updateSidebar()}} /> */}

        <div className={styles.actionButtons}>
          <div className={styles.actionLabel}>Secure account</div>
          <Button
            label={"Submit"}
            buttonOverrideStyle={styles.buttonOverrideStyle}
          />
        </div>
      </form>
    </div>
  );
};

export default OnBoardAccount;
